import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import * as Sentry from '@sentry/browser';
import { DatePickerInput } from 'rc-datepicker';
import moment from 'moment';
import 'moment/locale/cs.js';
import 'rc-datepicker/lib/style.css';

{/*
<input type="date" name={inputName} value={this.props.delkaStudia.nastup.value} onChange={(e) => {this.props.delkaStudia.nastup.value = e.target.value}} placeholder="Zadejte den nástupu" style={{width: "100%", boxSizing: "border-box"}} required />
*/}

class Nastup extends React.Component {
    render() {
        let inputName = `prihlaska[zeme][${this.props.zemeKey}][mesto][${this.props.mestoKey}][skola][${this.props.skolaKey}][kurz][${this.props.kurzKey}][nastup]`;
        const date = new Date(this.props.delkaStudia.nastup.value);
        return (
            <div>
                <div className="formRow mesto">
                    <label>Nástup:</label> 
                    {this.state.loading ?
                        <div>Náčítají se nástupní termíny...</div>
                        :
                            <div>
                                {this.state.nastupy.length > 0 && false ?
                                    <select name={inputName} value={this.props.delkaStudia.nastup.value} onChange={(e) => {this.props.delkaStudia.nastup.value = e.target.value}} required={this.props.kurzKey === 0 || true}>
                                        <option value="">-- Zvolte termín nástupu --</option>
                                        {this.state.nastupy.map((nastup, key) => {
                                            //let date = moment(nastup).format("D.M.YYYY");
                                            let date = new Date(nastup);
                                            date = date.getDate() +"."+ (date.getMonth()+1) + "." + date.getFullYear();
                                            return <option key={key} value={nastup}>{date}</option>
                                        })}
                                    </select>
                                    :   
                                    <div>
                                        <DatePickerInput
                                            showOnInputClick={true}
                                            readOnly={true}
                                            value={this.props.delkaStudia.nastup.value}
                                            dateFilter={(date) => date.day() === 1}
                                            onChange={(value) => { 
                                                const date = new Date(value);
                                                if (date.getDay() !== 1) {
                                                    alert("Kurzy začínají v pondělí, vyberte prosím den nástupu v pondělí.");
                                                    this.props.delkaStudia.nastup.value = "";
                                                    return false;
                                                } else {
                                                    this.props.delkaStudia.nastup.value = value;
                                                }
                                                
                                             }}
                                            className='kalkulace-datepicker'
                                        />
                                        <input type="hidden" name={inputName} value={moment(this.props.delkaStudia.nastup.value).format("YYYY-MM-DD")} />
                                        {date.getDay() !== 1 && <div><strong>Kurzy začínají v pondělí, vyberte prosím den nástupu v pondělí.</strong></div>}
                                    </div>
                                }
                            </div>
                            
                    }
                </div>
            </div>
        );
    }

    constructor(props) {
        super(props);

        this.state = {
            idKurzu: null,
            nastupy: [],
            loading: false,
            delkaStudia: null
        }
    }

    componentDidMount() {
        // this._loadNastup(this.props.kurz.value, this.props.delkaStudia.value);
    }

    componentWillReceiveProps(newProps) {
        // this._loadNastup(newProps.kurz.value, newProps.delkaStudia.value);
    }

    _loadNastup = (idKurzu, delkaStudia) => {
        if(idKurzu === this.state.idKurzu && delkaStudia === this.state.delkaStudia) return;
        this.setState({
            idKurzu: idKurzu,
            nastupy: [],
            loading: true,
            delkaStudia: delkaStudia
        });


        axios.get(this.props.store.apiUrl, {params: {seznam: "nastup", idKurzu: idKurzu, delka: delkaStudia}})
            .then((response) => {
                let nastupy = response.data; /*response.data.map((item) => {
                    return moment(item);
                });*/
                this.setState({
                    nastupy: nastupy,
                    loading: false
                });
            })
            .catch((error) => {
                Sentry.captureException(error);
                alert("Došlo k neočekáváné chybě(#A5) při načítání nástupních termínů. Prosím kontaktujte nás přímo.")
            });
    }

    _nastupFilter = (day) => {
        return this.state.nastupy.indexOf(day.format("YYYY-MM-DD")) >= 0;
    }

}

export default Nastup;


// WEBPACK FOOTER //
// ./resources/prihlaska/nastup.js